// extracted by mini-css-extract-plugin
export default {"editTrayCategoryModal_organism":"EditTrayCategoryModal_editTrayCategoryModal_organism__OZ2tQ","headerBox":"EditTrayCategoryModal_headerBox__iRdvE"};